import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { ConfigCatalogoComponent } from './config-catalogo/config-catalogo.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { ConfigIndicadoresComponent } from './config-indicadores/config-indicadores.component';
import { CargaInformacionComponent } from './carga-informacion/carga-informacion.component';
import { EscenariosProyectadosComponent } from './escenarios-proyectados/escenarios-proyectados.component';
import { ProyeccionesComponent } from './proyecciones/proyecciones.component';

const routes: Routes = [{
  path: 'app/proyecciones-financieras',
  component: ContenedorComponent,
  children: [
    {path: 'configuracion-catalogo', component: ConfigCatalogoComponent, canActivate: [authGuardSubmodule]},
    {path: 'configuracion-indicadores', component: ConfigIndicadoresComponent, canActivate: [authGuardSubmodule]},
    {path: 'carga-informacion', component: CargaInformacionComponent, canActivate: [authGuardSubmodule]},
    {path: 'proyecciones', component: ProyeccionesComponent, canActivate: [authGuardSubmodule]},
    {path: 'escenarios-proyectados', component: EscenariosProyectadosComponent, canActivate: [authGuardSubmodule]},
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProyeccFinancierasRoutingModule { }
